import { Component, OnInit } from '@angular/core';

@Component({
    template: require('./rastreamentos.component.html')
})
export class RastreamentosComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/rastreamentos.component.ts
 **/